const initialState = { responseJson: null, galleryRes: [], blogRes: [] };


const data = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_RESPONSE':
      return { ...state, responseJson: action.payload };
    case 'GALLERY_RES':
      return { ...state, galleryRes: action.payload };
    case 'BLOG_RES':
      return { ...state, blogRes: action.payload };
    default:
      return state
  }
}
export default data;
